import { Notify } from 'src/api/model/notify';
import { RequestBuilder } from 'src/api/common/request-builder';
import { Pagable } from 'src/constants/pagable';
import { RequestUtils } from 'src/utils/request-utils';
import { NotifySeenForm } from '../model/form/notify-seen-form';
import { NotifySearchForm } from '../model/search/notify-search-form';
import { Page } from '../common/page';

export class NotifyApi {
  getDataPagging(
    form: NotifySearchForm,
    pagable: Pagable,
  ): Promise<Page<Notify>> {
    const params = RequestUtils.merge(
      form,
      RequestUtils.initPageableParams(pagable),
    );
    return new RequestBuilder<Notify>()
      .url('/member/notify')
      .config({ params: params })
      .findAllPagging();
  }

  getAllUnSeen(): Promise<Notify[]> {
    return new RequestBuilder<Notify>()
      .url('/member/notify/getAllUnSeen')
      .findAll();
  }

  delete(id: string) {
    return new RequestBuilder<Notify>()
      .url(`/member/notify/${id}`)
      .delete();
  }

  makeSeen(form: NotifySeenForm) {
    return new RequestBuilder<Notify>()
      .url('/member/notify/makeSeen')
      .data(form)
      .post();
  }

  makeSeenAll() {
    return new RequestBuilder<Notify>()
      .url('/member/notify/makeSeenAll')
      .post();
  }
}

export const notifyApi = new NotifyApi();
